/**
 * System Requirements — static page stating the supported-browser policy
 * (Day 100's browser-support deliverable). The browser line is the SAME wording
 * as the arbi Login notice (src/pages/Login.tsx) — matched, not invented, so the
 * platform speaks with one voice.
 */
import { type JSX } from 'react';
import { Monitor } from 'lucide-react';
import { useDocumentTitle } from '../hooks/useDocumentTitle';

export default function SystemRequirements(): JSX.Element {
  useDocumentTitle('System Requirements');
  return (
    <div className="h-full overflow-auto">
      <div className="max-w-3xl mx-auto p-6 space-y-5">
        <div className="flex items-center gap-2">
          <Monitor size={18} className="text-accent" />
          <h1 className="text-xl font-semibold text-ink-bright">System Requirements</h1>
        </div>

        <section className="arbi-card p-5 space-y-2">
          <h2 className="text-sm font-semibold text-ink-bright">Supported browsers</h2>
          <p className="text-sm text-ink-secondary">
            Best experienced in Chrome. Firefox, Safari, and Edge are also supported.
          </p>
          <p className="text-xs text-ink-muted">
            Keep your browser updated to its latest version for the best experience.
          </p>
        </section>

        <section className="arbi-card p-5 space-y-2">
          <h2 className="text-sm font-semibold text-ink-bright">Requirements</h2>
          <ul className="text-sm text-ink-secondary space-y-1.5 list-disc ml-5">
            <li>JavaScript and cookies must be enabled.</li>
            <li>A stable internet connection.</li>
            <li>An Arbi account — access is by invitation only.</li>
          </ul>
        </section>
      </div>
    </div>
  );
}
